document.addEventListener('DOMContentLoaded',(event)=>{
let onLoadPageOffset = window.pageYOffset;
  let cartDrawer = document.querySelector('.cart-drawer');
  if(onLoadPageOffset > 48 ){
    cartDrawer.classList.remove('move_down');
  }else{
    cartDrawer.classList.add('move_down');
  }
document.addEventListener('scroll',(event)=>{
  if(window.scrollY > 48){
    cartDrawer.classList.remove('move_down');
  }else{
    cartDrawer.classList.add('move_down');
  }
})
})

// script.js
const images = document.querySelectorAll(".fade-in");

function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function handleScroll() {
  const buffer = 100; // Adjust this value as needed
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  
  images.forEach((image) => {
    const imageTopPosition = image.getBoundingClientRect().top;
    
    if (imageTopPosition - buffer <= viewportHeight) {
      image.classList.add("visible");
    }
  });
}

// Initially, check if any images are in view on page load
window.addEventListener("load", handleScroll);
// Check again when the user scrolls
window.addEventListener("scroll", handleScroll);

const productInfo = document.querySelector('.product-info');
const productGallery = document.querySelector('.product-gallery');

function adjustScroll() {
  if(productGallery){
    const galleryHeight = productGallery.getBoundingClientRect().height;
    // productInfo.style.maxHeight = `${galleryHeight}px `;
  }
}

// Call the function on load and whenever the window is resized
window.addEventListener('load', adjustScroll);
window.addEventListener('resize', adjustScroll);

// collecion ajax filters
 let tabs = document.querySelectorAll(".collection_tab");
  tabs.forEach((val)=>{
    val.addEventListener("click",(e)=>{
    e.preventDefault();
    let target = e.target; 
    document.querySelector(".collection_tab.active").classList.remove("active");
    target.classList.add("active");
    let href = target.getAttribute("href");
    centerActiveItemOnMobile();
    fetch(href)
    .then(response => response.text())
    .then(data => {

      let html_div = document.createElement('div');
      html_div.innerHTML = data;
      let html_dom = html_div.querySelector('#main_collection').innerHTML;                                                                                       
      document.querySelector('#main_collection').innerHTML = html_dom;
      history.replaceState(null, null, `${href}`);
    }); 
   })
  })

function centerActiveItemOnMobile() {
  if ($(window).width() <= 768) { // Adjust breakpoint as needed
    const activeItem = $('.collection_tab.active');
    if (activeItem.length) {
      const container = $('.collection_tabs_buttons');
      const containerWidth = container.width();
      const activeItemOuterWidth = activeItem.outerWidth(true);
      
      // Calculate total width of previous siblings
      let totalPreviousSiblingsWidth = 0;
      activeItem.prevAll().each(function() {
        totalPreviousSiblingsWidth += $(this).outerWidth(true);
      });
      
      container.animate({ scrollLeft: totalPreviousSiblingsWidth - 68 }, 300);
    }
  }
}
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


